import { useEffect, useRef } from 'react';

import { injectWhatfixScript } from 'swipeclock-frontend';
import { selectFeaturesAndReadyToInjectScript } from 'store/swipeclockUserSlice';
import { useSelector } from 'react-redux';

export function useAppendScriptForSwipeclockUser() {
  const whatfixRef = useRef(false);

  const { features, readyToInjectScript } = useSelector(
    selectFeaturesAndReadyToInjectScript
  ) ?? { features: [], readyToInjectScript: false };

  useEffect(() => {
    // Check if the script has already been whatfixRef via useScript ( check #1 )
    if (readyToInjectScript) {
      injectWhatfixScript({
        ref: whatfixRef,
        masterData: { features },
      });
    }
  }, [readyToInjectScript]);
}
